import React, { useState } from "react";

export default function ShareFlightModal({ missionData, onClose, socket }) {
  if (!missionData) return null;

  const [createdMissionId, setCreatedMissionId] = useState(null);

  const [crewEmails, setCrewEmails] = useState([""]);
  const [permissions, setPermissions] = useState({
    allowEdit: true,
    showMapView: true,
    enableChat: true,
  });
  const [message, setMessage] = useState(
    "Hi team — please review and confirm by 1600Z."
  );
  const baseUrl = "https://pirep-frontend.vercel.app";


  const flightroomUrl =
  createdMissionId
    ? `${baseUrl}/flightroom/${createdMissionId}`
    : "";


  const handleAddCrew = () => {
    setCrewEmails([...crewEmails, ""]);
  };

  const handleEmailChange = (index, value) => {
    const updated = [...crewEmails];
    updated[index] = value;
    setCrewEmails(updated);
  };


const handleCreateShareLink = async () => {

  try {

    const token =
      localStorage.getItem(
        "token"
      );

    if (!token) {

      alert(
        "No token found"
      );

      return;
    }

    // 🔥 Prefer preflight route BEFORE Start Flight
    // 🔥 fallback to activeFlight AFTER Start Flight
    let missionFlight =

      window.currentPreflightRoute ||

      JSON.parse(
        localStorage.getItem(
          "activeFlight"
        )
      );

    // 🔥 FALLBACK LIVE RESOLVE
    if (
      !missionFlight?.coords &&
      !missionFlight?.route?.coords
    ) {

      console.log(
        "⚠️ Preflight route missing — resolving live"
      );

      missionFlight =
        await resolveRouteWithCoords(
          missionData.route,
          missionData.origin,
          missionData.destination,
          missionData.altitude
        );

      console.log(
        "✅ Live-resolved mission route:",
        missionFlight
      );
    }

    console.log(
      "🧪 MISSION FLIGHT:",
      missionFlight
    );

    // 🔍 Detect route structure safely
    const coords =

      missionFlight?.coords ||

      missionFlight?.route?.coords ||

      [];

    const waypoints =

      missionFlight?.waypoints ||

      missionFlight?.route?.waypoints ||

      [];

    const routeText =

      missionFlight?.meta?.routeTextCurrent ||

      missionData?.route ||

      missionFlight?.routeText ||

      "";

    const originIcao =

      missionData?.origin ||

      missionFlight?.meta?.origin ||

      "";

    const destinationIcao =

      missionData?.destination ||

      missionFlight?.meta?.destination ||

      "";

    console.log(
      "🧪 DETECTED COORDS:",
      coords
    );

    console.log(
      "🧪 DETECTED WAYPOINTS:",
      waypoints
    );

    if (!coords?.length) {

      console.log(
        "❌ No coords in mission"
      );

      console.log(
        "🧪 FULL missionFlight object:"
      );

      console.log(
        missionFlight
      );

      alert(
        "No route coords available"
      );

      return;
    }

    // 🧭 CREATE MISSION
    const res = await fetch(
      "https://ficon-x.com/route/create-mission",
      {

        method: "POST",

        headers: {

          Authorization:
            `Bearer ${token}`,

          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({

          name:
            "Shared Flight"
        })
      }
    );

    const mission =
      await res.json();

    console.log(
      "🧭 Mission created:",
      mission
    );

    const missionId =
      mission.id;

    if (!missionId) {

      console.error(
        "❌ Mission ID missing"
      );

      alert(
        "Mission creation failed"
      );

      return;
    }

    // ✅ Save mission locally
    localStorage.setItem(
      "activeMissionId",
      missionId
    );

    // 🌐 AUTHORITATIVE GLOBAL
    window.__activeMissionId =
      missionId;

    localStorage.setItem(
      "activeMission",

      JSON.stringify({

        mission_id:
          missionId,

        captain: true,

        created:
          Date.now()
      })
    );

    sessionStorage.setItem(
      "missionRole",
      "captain"
    );

    console.log(
      "👨‍✈️ Mission role: captain"
    );

    // ✅ Save for flightroom URL
    setCreatedMissionId(
      missionId
    );

    // 🔌 JOIN SOCKET ROOM
    if (window.routeSocket) {

      console.log(
        "🔌 Joining mission room..."
      );

      window.routeSocket.emit(
        "join_mission",
        {

          mission_id:
            String(missionId)
        }
      );

    } else {

      console.error(
        "❌ routeSocket missing"
      );
    }

    // 🚀 SEND ROUTE STATE
    if (window.routeSocket) {

      console.log(
        "🚀 Sending mission route update..."
      );

      const missionPayload = {

        mission_id:
          String(missionId),

        state: {

          route: {

            routeText,

            coords,

            waypoints
          },

          originIcao,

          destinationIcao,

          altitude:

            missionFlight?.altitude ||

            missionData?.altitude ||

            null,

          tas:

            missionFlight?.tas ||

            missionData?.tas ||

            null,

          timeEnroute:

            missionFlight?.timeEnroute ||

            missionData?.timeEnroute ||

            null,

          totalFuel:

            missionFlight?.totalFuel ||

            missionData?.totalFuel ||

            null,

          timestamp:
            Date.now()
        }
      };

      console.log(
        "🧪 FINAL MISSION PAYLOAD:"
      );

      console.log(
        missionPayload
      );

      window.routeSocket.emit(
        "update_mission",
        missionPayload
      );
    }

    // 🔗 BUILD SHARE LINK
    const shareLink =

      `${window.location.origin}/?mission=${missionId}`;

    console.log(
      "🔗 Share link:",
      shareLink
    );

    await navigator.clipboard.writeText(
      shareLink
    );

    // 📧 SEND INVITES
    await fetch(
      "https://ficon-x.com/route/send_mission_invites",
      {

        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({

          crewEmails,

          shareLink,

          origin:
            originIcao,

          destination:
            destinationIcao,

          route:
            routeText,

          message
        })
      }
    );

    console.log(
      "✅ Share link copied"
    );

    alert(
      "✅ Share link copied to clipboard!"
    );

  } catch (err) {

    console.error(
      "❌ Failed to create share link:",
      err
    );

    alert(
      "Failed to create share link"
    );
  }
};


const handleCreateRoom = async () => {
  try {
    const response = await fetch(
      "https://rudy-judicative-informedly.ngrok-free.dev/create_mission",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          origin: missionData.origin,
          destination: missionData.destination,
          route: missionData.route,
          altitude: missionData.altitude,
          tas: missionData.tas,
          timeEnroute: missionData.timeEnroute,
          totalFuel: missionData.totalFuel,
          crewEmails,
          permissions,
          message,
        }),
      }
    );

    let result;
    try {
      result = await response.json();
    } catch (jsonErr) {
      console.error("❌ Failed to parse JSON:", jsonErr);
      alert("Server returned an invalid response.");
      return;
    }

    if (response.ok && result?.success && result?.mission_id) {
      const { mission_id } = result;

      // ✅ Save to localStorage so Start Flight works
      localStorage.setItem("lastSharedMissionId", mission_id);

      // 🧠 Emit mission to backend for shared session sync
      socket.emit("register_mission", {
        mission_id,
        missionData: {
          origin: missionData.origin,
          destination: missionData.destination,
          route: missionData.route,
          altitude: missionData.altitude,
          tas: missionData.tas,
          totalFuel: missionData.totalFuel,
          timeEnroute: missionData.timeEnroute,
          charts_selected: missionData.charts_selected || [],
          weather: missionData.weather || {},
          timestamp: missionData.timestamp || Date.now()
        }
      });

      alert("✅ Mission created and invites sent. You're the mission captain.");
      onClose();
    } else {
      console.error("❌ Invalid mission response:", result);
      alert(result?.error || "Mission creation failed — no mission ID returned.");
    }
  } catch (err) {
    console.error("❌ Network/server error during mission creation:", err);
    alert("Network or server error. Check your internet connection or try again later.");
  }
};


  return (
    <div className="p-6 bg-white rounded-xl shadow-xl w-full max-w-xl">
      <h2 className="text-xl font-bold mb-4">Share Flight Mission with Crew</h2>

      <div className="mb-3 text-sm text-gray-700 space-y-1">
        <div>📍 <strong>Route:</strong> {missionData.origin} ➔ {missionData.destination}</div>
        <div>📏 <strong>Route Code:</strong> {missionData.route}</div>
        <div>🛫 <strong>Altitude:</strong> {missionData.altitude} ft</div>
        <div>🚀 <strong>TAS:</strong> {missionData.tas} knots</div>
        <div>⏱️ <strong>ETE:</strong> {missionData.timeEnroute}</div>
        <div>⛽ <strong>Total Fuel:</strong> {missionData.totalFuel}</div>
      </div>

      {/* Crew emails */}
      <div className="mb-4">
        <label className="font-semibold text-sm mb-1 block">Add Crew Members</label>

        {crewEmails.map((email, idx) => (
          <input
            key={idx}
            type="email"
            placeholder="crew@example.com"
            value={email}
            onChange={(e) => handleEmailChange(idx, e.target.value)}
            className="mb-2 w-full border rounded px-3 py-2 text-sm"
          />
        ))}

        <button
          type="button"
          className="text-blue-600 text-sm mt-1"
          onClick={handleAddCrew}
        >
          + Add Crew Member
        </button>
      </div>

      <button onClick={handleCreateShareLink}>
  🔗 Generate Share Link
</button>

      {/* Flightroom link */}
      <div className="mb-4">
        <label className="font-semibold text-sm mb-1 block">Flightroom Link</label>
        <div className="flex items-center gap-2">
          <input
            type="text"
            readOnly
            value={flightroomUrl}
            className="flex-grow border rounded px-3 py-2 text-sm"
          />
          <button
            onClick={() => navigator.clipboard.writeText(flightroomUrl)}
            className="bg-blue-600 text-white px-3 py-2 rounded text-sm"
          >
            Copy
          </button>
        </div>
      </div>

      {/* Permissions */}
      <div className="mb-4 space-y-2">
        <div className="flex items-center justify-between">
          <span>Allow route editing</span>
          <input
            type="checkbox"
            checked={permissions.allowEdit}
            onChange={(e) =>
              setPermissions((p) => ({ ...p, allowEdit: e.target.checked }))
            }
            className="h-4 w-4"
          />
        </div>

        <div className="flex items-center justify-between">
          <span>Show my map view to others</span>
          <input
            type="checkbox"
            checked={permissions.showMapView}
            onChange={(e) =>
              setPermissions((p) => ({ ...p, showMapView: e.target.checked }))
            }
            className="h-4 w-4"
          />
        </div>

        <div className="flex items-center justify-between">
          <span>Enable crew chat</span>
          <input
            type="checkbox"
            checked={permissions.enableChat}
            onChange={(e) =>
              setPermissions((p) => ({ ...p, enableChat: e.target.checked }))
            }
            className="h-4 w-4"
          />
        </div>
      </div>

      {/* Optional message */}
      <div className="mb-4">
        <label className="font-semibold text-sm mb-1 block">Optional Message</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={3}
          className="w-full border rounded px-3 py-2 text-sm"
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-2">
        <button
          onClick={onClose}
          className="text-gray-600 border border-gray-300 px-4 py-2 rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleCreateRoom}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Create Shared Room
        </button>
      </div>
    </div>
  );
}
